import { BASE_URL } from '../constants/baseUrl';
import axiosInstance from '../utils/axiosInstance';
import logger from '../utils/logger';

class DashboardService {
  getCustomerStats = async () => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/v1/user/users/all?skip=1&limit=10`,
      );

      const customers = response.data?.data || [];
      const total = response.data?.total || 0;
      const kycDone = customers.filter(
        (customer) => customer.isKycCompleted,
      ).length;
      const kycPending = total - kycDone;

      return {
        totalUsers: total,
        kycCompleted: kycDone,
        kycPending,
      };
    } catch (error) {
      logger.error('Customer stats error:', error);
      return {
        totalUsers: 0,
        kycCompleted: 0,
        kycPending: 0,
      };
    }
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new DashboardService();
